<ng-template specCollectionHost></ng-template>    

<mat-dialog-content *ngIf="isErrorState"> 
    <ng-container>
        <p>An error occurred while loading spec. If error persist, please contact support.</p>
    </ng-container>
</mat-dialog-content>